'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require('babel-runtime/helpers/get');

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

exports.default = service;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _warning = require('fbjs/lib/warning');

var _warning2 = _interopRequireDefault(_warning);

var _messages = require('../core/messages');

var _messages2 = _interopRequireDefault(_messages);

var _isEqual = require('lodash/isEqual');

var _isEqual2 = _interopRequireDefault(_isEqual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function service(providers, Component, _ref) {
  var _class, _temp;

  var injector = _ref.injector,
      globalInjector = _ref.globalInjector,
      selector = _ref.selector;

  // + 获取HOC包装的组件的实例 > see:
  // https://github.com/RubaXa/Sortable/issues/713#issuecomment-169668921
  function getParantService(name) {
    return this._reactInternalInstance ? this._reactInternalInstance._context[name] : null;
  }
  // 优先级为：providers -> context -> parentContext -> globalService
  function getService(name) {
    var service = this._services && this._services[name] || this.context[name];
    return service || getParantService.call(this, name) || injector.getService(name) || globalInjector.getService(name);
  }

  var NewComponent = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(NewComponent, _Component);

    function NewComponent(props, context) {
      (0, _classCallCheck3.default)(this, NewComponent);

      var _this = (0, _possibleConstructorReturn3.default)(this, (NewComponent.__proto__ || Object.getPrototypeOf(NewComponent)).call(this, props, context));

      var services = _this._services = {};
      if (selector) {
        services.selector = selector;
      }

      if (Array.isArray(providers)) {
        providers.forEach(function (Provider) {
          (0, _warning2.default)(Provider.displayName, _messages2.default.displayName, 'contructor', 'service', 'Beatle');
          services[Provider.displayName] = injector.instantiate(Provider, Provider.displayName, getService.bind(_this));
        });
      } else {
        for (var name in providers) {
          services[name] = injector.instantiate(providers[name], name, getService.bind(_this));
        }
      }

      if (context.selector) {
        services.parentSelector = context.selector;
        context.selector = selector;
      }
      // 提升当前组件的context的优先级
      for (var _name in context) {
        if (services[_name] !== undefined) {
          context[_name] = services[_name];
        }
      }

      if (selector) {
        // context也从当前组件同一个级别
        for (var _name2 in selector.context) {
          if (_name2 === 'props') {
            // 每次获取props都是最新的
            Object.defineProperty(selector.context, 'props', {
              get: function get() {
                return _this.props;
              },
              enumerable: true,
              configurable: true
            });
          } else {
            selector.context[_name2] = getService.call(_this, _name2);
          }
        }

        if (selector.hookActions) {
          // hack react-redux 6.x
          // see: https://github.com/reduxjs/react-redux/blob/fa5857281a37545c7c036fb2499159b865b1c57d/src/components/connectAdvanced.js
          /* eslint-disable react/prop-types */
          var empty = {};
          _this._state = _this.props.location && _this.props.location.state || empty;
          var selectChildElement = _this.selectChildElement;
          _this.selectChildElement = function (derivedProps, forwardedRef) {
            var state = derivedProps.location && derivedProps.location.state || empty;
            if (_this._state !== state && !(0, _isEqual2.default)(_this._state, state)) {
              _this._hookProps = null;
              _this._state = state;
            }
            if (!_this._hookProps) {
              _this._hookProps = {};
              selector.hookActions.forEach(function (action) {
                var model = void 0;
                if (typeof action === 'function') {
                  var ret = action(derivedProps, _this.context);
                  if (ret !== undefined) {
                    Object.assign(_this._hookProps, ret);
                  }
                } else {
                  if (typeof action === 'string') {
                    model = selector.getModel(selector.bindings[0]);
                    var _name3 = action;
                    action = {
                      name: _name3
                    };
                  } else {
                    model = typeof action.model === 'string' ? selector.getModel(action.model) : action.model || selector.getModel(selector.bindings[0]);
                  }
                  if (model && model[action.name]) {
                    var params = action.getParams ? action.getParams(derivedProps, _this.context) : action.params;
                    if (params !== false) {
                      model[action.name](params);
                    }
                  }
                }
              });
            }
            Object.assign(derivedProps, _this._hookProps);
            return selectChildElement.call(_this, derivedProps, forwardedRef);
          };
        }

        // 完成后触发钩子函数
        try {
          selector.initialize && selector.initialize(_this.props);
        } catch (e) {
          window.console.error(e);
        }
      }
      return _this;
    }

    (0, _createClass3.default)(NewComponent, [{
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        (0, _get3.default)(NewComponent.prototype.__proto__ || Object.getPrototypeOf(NewComponent.prototype), 'componentWillUnmount', this) && (0, _get3.default)(NewComponent.prototype.__proto__ || Object.getPrototypeOf(NewComponent.prototype), 'componentWillUnmount', this).call(this);
        var services = this._services;
        for (var name in services) {
          if (services[name].destroy) {
            services[name].destroy();
          }
          if (services[name].dispose) {
            services[name].dispose();
          }
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var children = (0, _get3.default)(NewComponent.prototype.__proto__ || Object.getPrototypeOf(NewComponent.prototype), 'render', this).call(this);
        return _react2.default.createElement(
          NewComponent.childContext.Provider,
          { value: this._services },
          children
        );
      }
    }]);
    return NewComponent;
  }(Component), _class.displayName = Component.displayName || Component.name, _class.childContext = (0, _react.createContext)(), _temp);


  return NewComponent;
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/damo/service.js
// module id = 128
// module chunks = 0